import styled from 'styled-components';

// Estilos compartilhados dos blocos de análise de consumo (histórico por posto,
// demanda e previsão) — usados na aba de histórico da UC e no relatório.

export const Card = styled.div`
  border: 1px solid ${(props) => props.theme.color.ui.shade1};
  border-radius: 3px;
  padding: 16px 20px;
  margin-top: 24px;
  font-family: Montserrat;
  background: ${(props) => props.theme.color.bg.primary};
`;

export const CardTitle = styled.h4`
  font-size: 16px;
  font-weight: 700;
  color: ${(props) => props.theme.color.ui.orange};
  margin: 0 0 12px;
  display: flex;
  align-items: center;
  gap: 10px;
  flex-wrap: wrap;
`;

type Direction = 'rising' | 'falling' | 'stable';

const badgeColor = (d: Direction) =>
  d === 'rising' ? '#F42121' : d === 'falling' ? '#37b34a' : '#999999';

export const TrendBadge = styled.span<{ $direction: Direction }>`
  display: inline-flex;
  align-items: center;
  gap: 4px;
  font-size: 12px;
  font-weight: 600;
  padding: 3px 10px;
  border-radius: 3px;
  color: ${(props) => badgeColor(props.$direction)};
  border: 1px solid ${(props) => badgeColor(props.$direction)};
`;

export const Table = styled.table`
  width: 100%;
  border-collapse: collapse;
  font-size: 14px;
  color: ${(props) => props.theme.color.text.primary};

  th,
  td {
    padding: 8px 10px;
    text-align: right;
    border-bottom: 1px solid ${(props) => props.theme.color.ui.shade1};
    white-space: nowrap;
  }
  th:first-child,
  td:first-child {
    text-align: left;
  }
  th {
    font-size: 12px;
    font-weight: 600;
    color: ${(props) => props.theme.color.text.quaternary};
  }
  td.money {
    font-weight: 700;
    color: ${(props) => props.theme.color.text.secondary};
  }
`;

export const TableScroll = styled.div`
  overflow-x: auto;
`;

export const Note = styled.p`
  font-size: 12px;
  color: ${(props) => props.theme.color.text.quaternary};
  margin: 10px 0 0;
  line-height: 18px;
`;

export const Empty = styled.p`
  font-size: 14px;
  color: #999;
  margin: 8px 0 0;
`;

// Legenda centralizada no padrão do "Histórico de consumo (kWh)" do relatório
// (bolinha 16 px + gap 8 px entre ícone e texto) — 29/set/2026.
export const Legend = styled.div`
  display: flex;
  flex-wrap: wrap;
  justify-content: center;
  gap: 8px 40px;
  margin-top: 12px;

  span {
    display: flex;
    align-items: center;
    gap: 8px;

    svg {
      font-size: 16px;
      flex-shrink: 0;
    }
  }
`;

/* Gráfico dentro do relatório: sem borda (29/set/2026 — "retire as bordas de
   todos os gráficos") e título no padrão do "Histórico de consumo (kWh)":
   cinza, peso regular, centralizado. */
export const ReportChart = styled.div`
  margin-top: 24px;
  font-family: Montserrat;
`;

export const ReportChartTitle = styled.h4`
  text-align: center;
  font-weight: ${(props) => props.theme.font.title.weight.regular};
  color: ${(props) => props.theme.color.text.quaternary};
`;
